var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', [_c('form', [_c('div', {
    staticClass: "row mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Toon alle producten in levering")]), _c('br'), _c('b-checkbox', {
    attrs: {
      "switch": "",
      "value": "1",
      "unchecked-value": "0",
      "size": "lg"
    },
    model: {
      value: _vm.config.showAllProducts,
      callback: function ($$v) {
        _vm.$set(_vm.config, "showAllProducts", $$v);
      },
      expression: "config.showAllProducts"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("Sorteervolgorde")]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.config.sortOrder,
      expression: "config.sortOrder"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.config, "sortOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("Nieuwste eerst")]), _c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("Oudste eerst")])])])], 1)]), _vm._l(_vm.dispatchRequestsFiltered, function (dispatchRequest) {
    var _dispatchRequest$disp, _dispatchRequest$resp, _dispatchRequest$resp2, _dispatchRequest$resp3, _dispatchRequest$disp2, _dispatchRequest$disp3, _dispatchRequest$stor, _dispatchRequest$stor2;
    return _c('b-card', {
      key: dispatchRequest.id,
      staticClass: "dispatchRequest mb-4 mt-1 font-size-md",
      attrs: {
        "no-body": "",
        "data-id": dispatchRequest.id
      }
    }, [_c('b-card-header', {
      class: {
        'bg-midnight-bloom-light': !dispatchRequest.is_replaced
      },
      attrs: {
        "header-bg-variant": dispatchRequest.is_replaced ? 'light' : '',
        "data-drq-id": dispatchRequest.id
      }
    }, [_c('b-col', {
      staticClass: "px-0",
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "mb-0"
    }, [_c('span', {
      attrs: {
        "title": dispatchRequest.status
      }
    }, [_c('dispatch-request-icon', {
      staticClass: "mr-2",
      attrs: {
        "status": dispatchRequest.status
      }
    })], 1), _c('strong', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.dispatchRequestStatus(dispatchRequest.status, (_dispatchRequest$disp = dispatchRequest.dispatch_type) === null || _dispatchRequest$disp === void 0 ? void 0 : _dispatchRequest$disp.identifier))))]), dispatchRequest.status_reason ? _c('small', {
      staticClass: "mr-2"
    }, [_c('font-awesome-icon', {
      staticClass: "ml-2 text-info align-text-top",
      attrs: {
        "icon": "circle-info",
        "title": dispatchRequest.status_reason
      }
    })], 1) : _vm._e()])]), _c('b-col', {
      staticClass: "px-0",
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_vm.showDispatchRequestDeliveryFields(dispatchRequest) ? _c('h5', {
      staticClass: "mb-0"
    }, [_c('small', [_c('strong', [_vm._v("Uitleverdatum: ")]), dispatchRequest.dispatch_date ? _c('span', [_vm._v(_vm._s(_vm._f("date")(dispatchRequest.dispatch_date)))]) : _c('span', [_vm._v("onbekend")])])]) : _vm._e()]), _c('b-col', {
      attrs: {
        "cols": "11",
        "md": "5"
      }
    }, [_c('b-row', [_c('b-col', [_c('h6', {
      staticClass: "mb-0"
    }, [_c('small', [_c('strong', [_vm._v(_vm._s(_vm.$t('omt.gui.orders.label.location')) + ":")]), _vm._v(" " + _vm._s(_vm._f("dispatcherType")(dispatchRequest.dispatcher_type)) + " - " + _vm._s(_vm.getDispatcherName(dispatchRequest)) + " (" + _vm._s(dispatchRequest.dispatch_type.display_name) + ")")])]), _c('p', {
      staticClass: "text-truncate mb-0"
    }, [dispatchRequest.responsible_location ? _c('small', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": `${_vm.$t('omt.gui.orders.label.responsible-location')}: ${dispatchRequest.responsible_location.display_name}`
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('omt.gui.orders.label.responsible-location')) + ":")]), _vm._v(" " + _vm._s((_dispatchRequest$resp = dispatchRequest.responsible_location) === null || _dispatchRequest$resp === void 0 ? void 0 : _dispatchRequest$resp.location_type.display_name) + " - "), !_vm.hasAnyPermission(['locations.services.view', 'locations.services.edit']) ? _c('span', [_vm._v(_vm._s(dispatchRequest.responsible_location.display_name))]) : _c('b-link', {
      staticStyle: {
        "color": "inherit"
      },
      attrs: {
        "to": {
          name: 'EditLocationServices',
          params: {
            locationTypeIdentifier: (_dispatchRequest$resp2 = dispatchRequest.responsible_location) === null || _dispatchRequest$resp2 === void 0 ? void 0 : _dispatchRequest$resp2.location_type.identifier,
            locationIdentifier: (_dispatchRequest$resp3 = dispatchRequest.responsible_location) === null || _dispatchRequest$resp3 === void 0 ? void 0 : _dispatchRequest$resp3.identifier
          }
        },
        "title": "Bekijk locatie"
      }
    }, [_vm._v(_vm._s(dispatchRequest.responsible_location.display_name))])], 1) : _vm._e()])])], 1)], 1), _c('b-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "1"
      }
    }, [!dispatchRequest.is_replaced ? _c('font-awesome-icon', {
      staticClass: "text-info font-size-lg",
      attrs: {
        "icon": "star-of-life",
        "title": "Huidige status"
      }
    }) : _vm._e()], 1)], 1), _c('b-card-body', {
      staticClass: "pl-4 pb-3 pt-4",
      attrs: {
        "body-bg-variant": "default"
      }
    }, [_c('b-table-simple', {
      staticClass: "mb-0",
      attrs: {
        "stacked": "sm",
        "small": "",
        "borderless": ""
      }
    }, [_c('colgroup', [_c('col', {
      staticStyle: {
        "width": "110px"
      }
    }), _c('col', {
      staticStyle: {
        "width": "140px"
      }
    }), _c('col', {
      staticStyle: {
        "width": "auto"
      }
    }), _c('col', {
      staticStyle: {
        "width": "210px"
      }
    })]), _c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("Aantal")]), _c('b-th', [_vm._v("Artikel nr")]), _c('b-th', [_vm._v("Naam")]), _c('b-th', [_vm._v("Extra informatie")])], 1)], 1), _c('b-tbody', _vm._l(dispatchRequest.dispatch_request_lines, function (line) {
      var _line$product_name, _vm$getSalesOrderLine, _vm$getSalesOrderLine2, _vm$getReturnReason$d, _vm$getProductState$d;
      return _vm.config.showAllProducts === '1' || line.product_identifier === _vm.dispatchRequestLine.product_identifier ? _c('b-tr', {
        key: line.id,
        class: {
          'opacity-5': line.product_identifier !== _vm.dispatchRequestLine.product_identifier
        }
      }, [_c('b-td', {
        attrs: {
          "stacked-heading": "Aantal"
        }
      }, [_vm._v(" " + _vm._s(line.quantity) + " ")]), _c('b-td', {
        attrs: {
          "stacked-heading": "Artikel nr"
        }
      }, [_vm._v(" " + _vm._s(line.product_identifier) + " ")]), _c('b-td', {
        attrs: {
          "stacked-heading": "Naam"
        }
      }, [_vm._v(_vm._s((_line$product_name = line.product_name) !== null && _line$product_name !== void 0 ? _line$product_name : _vm.getSalesOrderLine(line.sales_order_line_id).product_name))]), _c('b-td', {
        attrs: {
          "stacked-heading": "Extra informatie"
        }
      }, [dispatchRequest.storage_location_id ? _c('small', [_c('i', [_vm._v("Gescand: " + _vm._s(line.final_scanned_quantity))])]) : _vm._e(), (_vm$getSalesOrderLine = _vm.getSalesOrderLine(line.sales_order_line_id)) !== null && _vm$getSalesOrderLine !== void 0 && (_vm$getSalesOrderLine2 = _vm$getSalesOrderLine.promotions) !== null && _vm$getSalesOrderLine2 !== void 0 && _vm$getSalesOrderLine2.length ? _c('p', {
        staticClass: "m-0"
      }, [_c('small', {
        staticClass: "text-primary",
        staticStyle: {
          "text-decoration": "underline dotted",
          "cursor": "default"
        },
        attrs: {
          "id": `promotions_${line.id}`
        }
      }, [_vm._v(" " + _vm._s(_vm.getSalesOrderLine(line.sales_order_line_id).promotions.length) + " promotie"), _vm.getSalesOrderLine(line.sales_order_line_id).promotions.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e()]), _c('b-popover', {
        key: line.id,
        attrs: {
          "target": `promotions_${line.id}`,
          "triggers": "hover",
          "placement": "auto",
          "no-fade": "",
          "delay": "0",
          "custom-class": "promotion-popover"
        }
      }, [_c('promotion-lines', {
        staticStyle: {
          "background": "white"
        },
        attrs: {
          "promotion-lines": _vm.getSalesOrderLine(line.sales_order_line_id).promotions
        }
      })], 1)], 1) : _vm._e(), dispatchRequest.status.startsWith('return-') ? _c('small', [_c('strong', [_vm._v("Retourreden:")]), _vm._v(" " + _vm._s((_vm$getReturnReason$d = _vm.getReturnReason(line.return_reason_id).display_name) !== null && _vm$getReturnReason$d !== void 0 ? _vm$getReturnReason$d : 'onbekend')), _c('br')]) : _vm._e(), dispatchRequest.status === 'return-received' ? _c('small', [_c('strong', [_vm._v("Staat:")]), _vm._v(" " + _vm._s((_vm$getProductState$d = _vm.getProductState(line.product_state_id).display_name) !== null && _vm$getProductState$d !== void 0 ? _vm$getProductState$d : 'onbekend')), _c('br')]) : _vm._e()])], 1) : _vm._e();
    }), 1)], 1)], 1), _c('b-card-footer', {
      attrs: {
        "footer-bg-variant": "light",
        "footer-border-variant": "light"
      }
    }, [_c('b-col', {
      staticClass: "pr-4 pl-0 text-black-50",
      attrs: {
        "cols": "3"
      }
    }, [_vm.showDispatchRequestDeliveryFields(dispatchRequest) ? _c('div', [dispatchRequest.carrier ? _c('carrier-icon', {
      staticClass: "carrier-icon d-inline-block align-middle",
      attrs: {
        "carrier": dispatchRequest.carrier.identifier
      }
    }) : _vm._e(), _c('span', {
      staticClass: "d-inline-block ml-2"
    }, [_vm._v(_vm._s(dispatchRequest.carrier ? dispatchRequest.carrier.display_name : ''))]), _vm._v(" → " + _vm._s(dispatchRequest.carrier_method ? dispatchRequest.carrier_method.display_name : 'Vervoersmethode onbekend') + " ")], 1) : _vm._e()]), _c('b-col', {
      staticClass: "pr-4 text-black-50",
      attrs: {
        "cols": "3"
      }
    }, [dispatchRequest.tracking_codes.length ? _c('span', [_vm._v(" Track & trace: "), _vm._l(dispatchRequest.tracking_codes, function (trackingCode, index) {
      return _c('a', {
        staticClass: "text-info d-inline-block mx-1",
        attrs: {
          "href": trackingCode.url,
          "target": "_blank"
        }
      }, [_vm._v("[" + _vm._s(index + 1) + "]")]);
    })], 2) : _vm._e()]), _c('b-col', {
      staticClass: "pr-4",
      attrs: {
        "cols": "3"
      }
    }, [_c('span', {
      staticClass: "text-black-50"
    }, [_vm._v("Laatste update:")]), _vm._v(" " + _vm._s(_vm._f("datetime")(dispatchRequest.updated_at)) + " ")]), _c('b-col', {
      staticClass: "text-black-50",
      attrs: {
        "cols": "3"
      }
    }, [dispatchRequest.dispatch_request_batch_id && _vm.hasPermission('orders.batch.process') ? _c('span', [_c('strong', [_vm._v("In batch: ")]), _c('b-link', {
      attrs: {
        "to": {
          name: 'ShipmentBatchView',
          params: {
            locationTypeIdentifier: dispatchRequest.dispatcher_type,
            locationIdentifier: dispatchRequest.dispatcher_identifier,
            batchIdentifier: (_dispatchRequest$disp2 = dispatchRequest.dispatch_request_batch) === null || _dispatchRequest$disp2 === void 0 ? void 0 : _dispatchRequest$disp2.identifier
          }
        }
      }
    }, [_vm._v(" " + _vm._s((_dispatchRequest$disp3 = dispatchRequest.dispatch_request_batch) === null || _dispatchRequest$disp3 === void 0 ? void 0 : _dispatchRequest$disp3.identifier) + " ")]), _c('br')], 1) : _vm._e(), dispatchRequest.storage_location_id ? _c('span', [_c('strong', [_vm._v("In sorteerzone:")]), _vm._v(" " + _vm._s((_dispatchRequest$stor = dispatchRequest.storage_location) === null || _dispatchRequest$stor === void 0 ? void 0 : _dispatchRequest$stor.storage_zone.display_name) + " → " + _vm._s((_dispatchRequest$stor2 = dispatchRequest.storage_location) === null || _dispatchRequest$stor2 === void 0 ? void 0 : _dispatchRequest$stor2.display_name) + " ")]) : _vm._e()])], 1)], 1);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }